
<div style="position:relative; z-index: 100; width: 100%;    ">
	<nav class="navbar navbar-expand-md " style="position: fixed; width: 100%; top:0;   margin: 0;">
  <div class="container">
    <a style="width: 210px !important;" class="navbar-brand " [routerLink]="['']">
      <img class="img-fluid " src="assets/img/military.png">
    </a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
<span class="navbar-toggler-icon"></span>
    </button>
          <div class="collapse navbar-collapse" [class.show]="isNavbarOpen">
      <ul class="navbar-nav me-auto">
        <li class="nav-item">

    <a class="nav-link" [routerLink]="['']">Home</a>
  </li>

  <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages/about/index.html"
      >About Us</a
    >
  </li>
   <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages/network/index.html"
      >Network</a
    >
  </li>
   <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/home/index.html"
      >Hub</a
    >
  </li>
  
  <li class="nav-item">
    <a
      class="nav-link"
      style="white-space: nowrap"
      [routerLink]="['/cf']"
      >Card Features</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      style="white-space: nowrap"
      [routerLink]="['/package']"
      >View Services</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      style="white-space: nowrap"
      [routerLink]="['/ai']"
      >Additional Features</a
    >
  </li>
  
 
      </ul>
    </div>
  </div>
</nav>
</div>

<!----end navbar--->

<!---HERO SECTION---->
<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Air_Combat_Command.png" alt="Image">
          <h3 class="text-center">Air Combat Command</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/air_force_military_soldiers.png" alt="image">
          <h3 class="text-center">Air Force Military Soldiers</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Davis-Monthan_Air_Force_Base.png" alt="Image">
          <h3 class="text-center">Davis Monthan Air Force Base</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/female_dress_blues.png" alt="Image">
          <h3 class="text-center">Female dress blues</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/GAO-Military_women.jpg" alt="Image">
          <h3 class="text-center">GAO Military women</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Marine_Corps.jpeg" alt="Image">
          <h3 class="text-center">Marine Corps</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Marines_male_and_female_dress blue_uniforms.png" alt="Image">
          <h3 class="text-center">Marines male & female </h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Oklahoma Guard, Air Force Conduct Joint MEDEVAC Training.png" alt="Image">
          <h3 class="text-center">Air Force Training</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Sneads Ferry woman makes history as first female MEU sergeant major.png" alt="Image">
          <h3 class="text-center">First female MEU sergeant major</h3>
        </div>
      </div>
    </div>
  </div>
</section>
<!---END HERO SECTION---->

<!---UMYO Military SECTION---->

<section>
  <div class="resident  pt-5 bg-light">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-9 ps-md-0 mb-5" data-aos="flip-down">
          <div class="membership-cards">
          <div class="tribe mt-md-5 card mb-5" id="tribe">
            <h2 class="fw-bold">Welcome to UMYO Military — Where Athletes Own the Game</h2>
            <p data-aos="fade-up"><b>UMYO Military</b> is a next-generation digital platform built exclusively for athletes of all levels — from high school standouts to pro legends. Designed with sports in mind, UMYO Military provides a secure and empowering space where athletes can train, earn, connect, and grow — with the support of businesses that believe in their future.</p>
            
            <p data-aos="fade-up">This isn’t just about stats and highlights — it’s about ownership, opportunity, and community. Whether you’re a player, coach, content creator, or sports entrepreneur, UMYO Military equips you with the tools to level up your game — on and off the field.</p>
            <p><strong>For just $9.99/month, members get access to:</strong></p>
            <ul class="">
              <li data-aos="fade-up">Athlete-focused livestreaming and exclusive sports content</li>
              <li data-aos="fade-up">Custom e-commerce stores for merch, gear, and digital products</li>
              <li data-aos="fade-up">Secure messaging with fans, brands, and peers</li>
              <li data-aos="fade-up">Weekly prize giveaways, business vouchers, and scholarships</li>
              <li data-aos="fade-up">Athlete marketing tools and monetization features</li>
              <li data-aos="fade-up">A gated community where athletes control their brand and platform</li>
            </ul>
          <div class="haven" id="haven" style="display: none">

            <h3 class="fw-bold my-4" data-aos="fade-up">
              Why UMYO Military?
            </h3>
            <p>Because we believe in investing where it counts — <strong>our athletes</strong>. Each week, we directly support the sports community through:</p>
            <ul class="">
              <li data-aos="fade-up">Cash scholarships for students attending HBCUs and other universities</li>
              <li data-aos="fade-up">Rent, training, and travel support for rising stars</li>
              <li data-aos="fade-up">Gift cards and vouchers for gear from Black-owned and athlete-backed brands</li>
              <li data-aos="fade-up">Free promotion for athlete-owned businesses and creative projects</li>
            </ul>

            <p data-aos="fade-up">
              <strong>Business owners and sponsors</strong> can get involved starting at just <strong>$19.99/month</strong> — with branding, athlete partnerships, and premium promotional packages available during registration.
            </p>

  
            <p>
              Our tech partner, <strong>UMYO Wall Street of Technology</strong>, powers the platform — so athletes can focus on winning, creating, and building their legacy. From livestreams to store sales to mentorship programs, we make it simple to thrive in one trusted place.
            </p>

             <p>
              This is more than a platform — it’s a <strong>movement</strong> for athletic excellence, empowerment, and economic circulation.
              If you're ready to grow your fanbase, monetize your talent, and connect with a powerful network that champions you — <span>UMYO Military</span> is your arena.
            </p>

            <h3 class="fw-bold my-4">
              Call-to-Action Section:
            </h3>

            <p> <b>BJoin UMYO Military for $9.99/month<br>Launch your athlete brand for just $19.99</b></p>
            <p>Gain access to powerful digital tools, exclusive giveaways, and your own branded e-store. Business owners can sponsor athletes or expand visibility through our affordable packages</p>

                <strong>No ads. No algorithms. No middlemen.</strong>
                <p class="lead fs-5"> Just ownership, impact, and unstoppable energy.</p>

                <ul>
                  <li class="fw-bold">Join the Movement</li>
                  <li class="fw-bold">Explore UMYO Military</li>
                  <li class="fw-bold">Fuel the Future of Athletics</li>
                </ul>

            
            <button  id="less" class="btn btn-hover-purple border-dark gap-2 mt-4" data-aos="fade-up">
            Read Less
            </button>
            </div>
            <button  id="more" class="btn btn-hover-purple border-dark gap-2 mt-4">
            Read More
            </button>
          </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!---END UMYO Military SECTION---->

<!----POWER SECTION--->
<section  class="power">
       <div class="container-fluid srice py-5">
            <div class="container py-5">
        <h1 class="text-white text-center  mb-3" style="font-weight: 600; ">UMYO Military Members </h1>
        <div class="row">
             <div class="col-lg-5 mt-5">
                <!-- <h4 class="mb-4 text-white">Search For NBA Players Connects Here</h4> -->
                
                          <form [formGroup]="form2" class="text-center">

<div class="row">
                     <div class="col-lg-6 mb-4">
                <input
                  type="name"
                  formControlName="selectedName"
                  class="form-control"
                  placeholder="Name"
                />
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedType"
                >
                  <option selected value="" disabled>Type</option>
                  <option *ngFor="let item of type" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedBranch"
                >
                  <option selected value="" disabled>Military Branches</option>
                  <option *ngFor="let item of branch" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedRank"
                >
                  <option selected value="" disabled>Military Rankings</option>
                  <option *ngFor="let item of ranking" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedStateType"
                >
                  <option selected value="" disabled>States</option>
                  <option *ngFor="let item of state" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedBase"
                >
                  <option selected value="" disabled>Base</option>
                  <option *ngFor="let item of base" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6">
                <h4 class="mb-4 text-white text-center">
                  "IAM" Pledge To Report Violent Crime
                </h4>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedLocation"
                >
                  <option selected value="" disabled>Location</option>
                  <option *ngFor="let item of location" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedBusiness"
                >
                  <option selected value="" disabled>Business Type</option>
                  <option *ngFor="let item of businessType" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedGender"
                >
                  <option selected value="" disabled>Gender</option>
                  <option *ngFor="let item of gender" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <input
                  type="text"
                  formControlName="selectedCity"
                  class="form-control"
                  placeholder="City"
                />
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedRace"
                >
                  <option selected value="" disabled>Race</option>
                  <option *ngFor="let item of race" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
                   
                    <div class="col-lg-6 mb-4">
                        <button  (click)="searchCards()"
                  [disabled]="!form2.valid" class="btn  text-white py-2 px-5 w-100" style="background: #CC9B2D;">Search</button>
                    </div>   
                </div>

                  </form>


                
                <p class="rounded mb-4 text-white py-2 px-3 my-5 " style="background: #CC9B2D;">Cards</p>
                 <p
              class="text-white mb-4"
              style="cursor: pointer"
              [routerLink]="'/cards/share-card/' + card.id"
              *ngFor="let card of cardsSearched"
            >
              {{ card.cardTitle }}
            </p>
            </div>
            <div class="col-lg-7 mt-5">
             <div class="d-flex position-relative justify-content-center">
              <!-- Nav pills -->
             <div class="element">
                <button                           [class.active]="showLoginTab"
      (click)="checkRoute()" class="btn active">Login</button>
                <button (click)="checkRoute()"
                  [class.active]="!showLoginTab" class="btn">Register</button>
              </div>

              <!-- Tab panes -->
              <div class="tab-content rounded p-4 bg-light">
                
                <!-- Login Tab -->
<div                 [class.active]="showLoginTab" [class.inactive]="!showLoginTab"
 id="login" class="login">
                   <div class="text-center mb-5">
                    <h1>UMYO Military</h1>
                    <p>Register to Connect with Your Community</p>
                  </div>

                  <h2 class=" mb-3" >Login</h2>
                  <div class="row">
                                            <form [formGroup]="form">
                  <div class="row">
                   <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="email"
                          id="email"
                          class="form-control"
                          formControlName="email"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('email')?.hasError('required') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Email is required.
                        </div>
                        <div
                          *ngIf="
                            form.get('email')?.hasError('email') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Invalid email format.
                        </div>
                      </div>
                    </div>


                    <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >*</sup
                          >
                        </label>
                        <input
                          type="password"
                          id="password"
                          class="form-control"
                          formControlName="password"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('password')?.hasError('required') &&
                            form.get('password')?.touched
                          "
                          class="text-danger"
                        >
                          Password is required.
                        </div>
                      </div>
                      <div class="form-group" style="padding-top: 10px">
                        <label
                          style="
                            font-size: 16px;
                            font-weight: 400;
                            text-decoration: underline;
                            cursor: pointer;
                          "
                          [routerLink]="['/forgot-password']"
                          >Forgot Password?
                        </label>
                      </div>
                    </div>


                    <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                    <div class="text-center">
                      <button       (click)="openAgeModal('login')"
                                        [disabled]="!form.valid" class="btn  text-white py-3 px-5" style="background: #CC9B2D;">Submit</button>
                    </div>
                  </div>

</form>
                  </div>
                </div>

                <!-- Register Tab -->
  <div                 [class.active]="!showLoginTab" [class.inactive]="showLoginTab"
 id="regis" class="register" >             
 
                <form [formGroup]="form3">
                    <div class="text-center mb-5">
                      <h1>UMYO Military</h1>
                    </div>
                    <div class="row text-center mb-5">
                      <div class="col-md-3">
                        <p>Starting at</p>
                        <h1>$9.99</h1>
                        <p>Monthly</p>
                      </div>
                      <div class="col-md-1 d-none d-lg-block">
                        <div style="height: 100%; border-left: 2px solid #ccc;"></div>
                      </div>
                      <div class="col-md-6">
                        <p class="text-start">Includes:</p>
                        <ul class="text-start">
                          <li>40% off all UMYO Military products</li>
                          <li>3 free property listings per agent</li>
                          <li>Free standard CRM integrations</li>
                        </ul>
                      </div>
                    </div>

                    <h2 class=" mb-4">Register</h2>
                    <div class="row">
                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >First Name
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerFirstName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerFirstName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Last Name
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="text"
                          formControlName="registerLastName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerLastName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Phone Number
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerPhone"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerPhone')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>


                      <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerEmail')?.touched ||
                                !form3.get('registerEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Confirm Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerConfirmEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerConfirmEmail')?.touched ||
                                !form3.get('registerConfirmEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >* </sup
                          ><sup style="color: red; font-size: 14px"
                            >( Length Should be greater than 6 )</sup
                          >
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          required
                          formControlName="registerPassword"
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerPassword')?.touched ||
                                !form3.get('registerPassword')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>



                     <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Gender<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        formControlName="registerGenderType"
                        class="form-select"
                        aria-label="Default select example"
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerGenderType')?.touched ||
                              !form3.get('registerGenderType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of gender" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >States<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        formControlName="registerStateType"
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerStateType')?.touched ||
                              !form3.get('registerStateType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of state" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Race<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerRaceType')?.touched ||
                              !form3.get('registerRaceType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        class="form-select"
                        aria-label="Default select example"
                        formControlName="registerRaceType"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of race" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >City
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerCityType"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerCityType')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Type<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerType')?.touched ||
                              !form3.get('registerType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        formControlName="registerType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>

                        <option *ngFor="let item of type" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Military Branches<sup
                          style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerBranch')?.touched ||
                              !form3.get('registerBranch')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerBranch"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of branch" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Military Rankings<sup
                          style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerRank')?.touched ||
                              !form3.get('registerRank')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerRank"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of ranking" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Base<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerBase')?.touched ||
                              !form3.get('registerBase')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerBase"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>

                        <option *ngFor="let item of base" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Location<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerLocation')?.touched ||
                              !form3.get('registerLocation')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerLocation"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of location" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Business Type<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerBusiness')?.touched ||
                              !form3.get('registerBusiness')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerBusiness"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option
                          *ngFor="let item of businessType"
                          [value]="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>


                      <div class="col-md-12 mb-3">
                        <label class="form-label" style="font-size: 18px;">Enter Referral Code </label>
                        <input                           formControlName="registerReferralCode"
 type="text" class="form-control" >
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                      </div>
                    </div>
                    <div (click)="submitForm()" class="text-center">
                      <button      (click)="openAgeModal('signup')"
                      [disabled]="!form3.valid"
                                         type="submit" class="btn  text-white py-3 px-5" style="background: #CC9B2D;">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            </div>
        </div>
    </div>
  </div>
     </section>

<!---END POWER SECTION---->


<!---- CARDS SECTION--->
<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/The_Last_Skirt_Mandate_in_Marine_Corps.jpg" alt="Image">
          <h3 class="text-center">The Last Skirt Mandate in Marine Corps</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Units_need_more_fit,_disciplined_soldiers.png" alt="Image">
          <h3 class="text-center">Units need more fit, disciplined soldiers</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/US_Marine_Corps.png" alt="Image">
          <h3 class="text-center">US Marine Corps</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/Usmc_new_female_dress_blues_new_arrivals.jpg" alt="Image">
          <h3 class="text-center">Usmc new female dress blues new arrivals</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-up" >
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/U.S_Marine_Corps.jpg" alt="Image">
          <h3 class="text-center">U.S Marine Corps</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/first_female_Marine_Corps.jpg" alt="Image">
          <h3 class="text-center">First female Marine Corps</h3>
        </div>
      </div>
    </div>
  </div>
</section>

<!----END CARDS SECTION--->

<footer>
  <div class="container">
    <h3>Own Your Platform. Build Your Future. Join the UMYO Military.</h3>
    <h6>A gated digital community created for us — where culture thrives, wealth circulates, and power is shared.</h6>
  </div>
</footer>



<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div class="outerCard" style="min-height: 30vh; cursor: pointer">
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->
          <!-- hide stripe  -->
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button> -->
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="paypalClick()"
          >
            paypal
          </button>
        </div>
        <div *ngIf="selectedPackage?.price == '0'">
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="continuePaymentButton()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ paypalTitleMessage }}</h3>
          <p style="padding-top: 15px">{{ paypalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <form class="checkout-form" [formGroup]="paymentForm">
            <h3>
              Amount
              {{
                selectedPackage?.net_price
                  ? selectedPackage?.net_price
                  : selectedPackage?.price
              }}
            </h3>
            <div class="row">
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-number"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Card Number 16 Digit (Without Dashes)</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-number"
                    data-stripe-element="cardNumber"
                    formControlName="cardNumber"
                    placeholder="XXXXXXXXXXXXXXXX"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-expiry"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Expiration Date in (MM/YY) Format including /
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="card-expiry"
                    data-stripe-element="expiryDate"
                    formControlName="expiryDate"
                    placeholder="MM/YY"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-cvc"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >CVC 3 Digit</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-cvc"
                    data-stripe-element="cvc"
                    formControlName="cvc"
                    placeholder="XXX"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div
                class="col-md-12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding-top: 10px;
                "
              >
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-toggle="modal"
                  id="pay-button"
                  (click)="pay()"
                >
                  Pay Now
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showAgeModal, 'd-block': showAgeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Are You 18+ of your age?</h3>
        </div>
        <p style="padding: 8px">
          You must be at least 13 years old to use the Service. However,
          children of all ages may use the Service and PLTalk Kids (where
          available) if enabled by a parent or legal guardian. Permission by
          Parent or Guardian If you are under 18, you represent that you have
          your parent or guardian’s permission to use the Service. Please have
          them read this Agreement with you. If you are a parent or legal
          guardian of a user under the age of 18, by allowing your child to use
          the Service, you are subject to the terms of this Agreement and
          responsible for your child’s activity on the Service. You can find
          tools and resources to help you manage your family’s experience on
          PLTalk in our Help Center
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirmAge()">
          Yes
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAgeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
